import React, { useEffect, useState } from 'react'
import GalleryUploadCard from './GalleryUploadCard/GalleryUploadCard';

const UploadGallery = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
        const stored = sessionStorage.getItem("isSidebarOpen");
        return stored !== null ? JSON.parse(stored) : true;
      });
    
    
      useEffect(() => {
        const interval = setInterval(() => {
          const stored = sessionStorage.getItem("isSidebarOpen");
          const parsed = stored !== null ? JSON.parse(stored) : true;
    
          if (parsed !== isSidebarOpen) {
            setIsSidebarOpen(parsed);
          }
        }, 10);
    
        return () => clearInterval(interval);
      }, [isSidebarOpen]);
    return (
        <div
            className={`content-container ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
            style={{ marginTop: "100px" }}
        >
            <div className="page-inner-wrapper">

                <h2 className="mb-4">Gallery</h2>
                <div className="row justify-content-center">
      <div className="col-lg-10">
        <GalleryUploadCard />
      </div>
    </div>
            </div>
        </div>

    )
}

export default UploadGallery